module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1002-67b7f2784b4f35f80c96c842a7840ea4.png";